<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-card-title class="toolbar primary white--text">
          <v-icon dark>
            note_add
          </v-icon>
          <h3
            class="title ml-2"
          >
            Show Settlement History
          </h3>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="onToggleOpen"
          >
            X
          </v-btn>
        </v-card-title>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="history"
          :loading="isLoading"
          :expand="expand"
          :no-data-text="getNoDataText()"
          :pagination.sync="pagination"
          item-key="timestamp"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr
              :active="props.selected"
              @click="props.expanded = !props.expanded"
            >
              <td>
                {{ props.item.id }}
              </td>
              <td>
                {{ props.item.status }}
              </td>
              <td>
                {{ props.item.eventType }}
              </td>
              <td style="color: red">
                {{ getErrorDetails(props.item) }}
              </td>
              <td style="text-align:center">
                <v-tooltip
                  v-if="isMigrationEvents(props.item)"
                  top
                  dark
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="green"
                      v-on="on"
                    >
                      check_circle
                    </v-icon>
                  </template>
                  <span>
                    This Event is a Migration Event ("{{ props.item.migration || 'undefined' }}")
                    <br>
                    Created manually by Script.
                  </span>
                </v-tooltip>
              </td>
              <td class="text-xs">
                {{ (new Date(props.item.timestamp)).toISOString() }}
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <div class="expansion">
              <code
                class="d-block w-100 text-xs-left"
              >{{ props.item.data }}
              </code>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  name: 'ShowSettlementHistoryDialog',

  props: {
    type: {
      type: String,
      required: true,
      default: 'settlement',
    },
    settlementId: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      expand: false,
      selected: [],
      selectedUser: null,
      isOpenProp: this.isOpen,
      isLoading: false,
      history: [],
      pagination: {
        rowsPerPage: -1,
      },
      search: '',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Status', value: 'status' },
        { text: 'EventType', value: 'eventType' },
        { text: 'Error', value: 'error' },
        { text: 'Migration', value: 'migration' },
        { text: 'Updated At', value: 'timestamp' },
      ],
    };
  },
  async mounted() {
    this.isLoading = true;
    if (this.type === 'settlement') {
      await this.$store.dispatch('fetchStrategiesSettlementHistory', this.settlementId);
      this.history = this.$store.state.strategiesSettlementStore.settlementHistory;
    } else {
      await this.$store.dispatch('fetchCanceledSettlementHistory', this.settlementId);
      this.history = this.$store.state.canceledSettlementsStore.canceledSettlementHistory;
    }
    this.isLoading = false;
  },
  methods: {
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },
    isMigrationEvents(item) {
      // Regular: id, timestamp, data, eventType, status
      return (Object.keys(item).length > 5);
    },
    getNoDataText() {
      if (this.isLoading) {
        return 'Loading...';
      }

      return 'no data';
    },
    getErrorDetails(item) {
      if (item.eventType === 'orderFailed') {
        if (item.data.orderType === 'VAULT') {
          return item.data.additionalInfo.errorDetails;
        }
        if (item.data.orderType === 'STO' && item.data.additionalInfo.error) {
          try {
            return JSON.parse(item.data.additionalInfo.error).error.details[0].description;
          } catch (e) {
            return item.data.additionalInfo.error;
          }
        }
      } else if (item.eventType === 'paymentFailed') {
        return item.data.additionalInfo.errors;
      } else if (item.data.additionalInfo.errorMessage) {
        return item.data.additionalInfo.errorMessage;
      } else if (item.data.additionalInfo.errors) {
        return item.data.additionalInfo.errors;
      }

      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .expansion {
    background-color: antiquewhite;
    margin:10px;
    padding: 5px
  }
</style>



// WEBPACK FOOTER //
// src/components/settlements/dialog/ShowSettlementHistory.vue